import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/es5/locale/de'
// import WORK_VUETIFY_ICON_SET from '@/components/global_components/work_icons/WORK_VUETIFY_ICON_SET';
import GLOBAL_VUETIFY_ICON_SET from '@/components/global_components/work_icons/GLOBAL_VUETIFY_ICON_SET';
import customVuetifyThemes from '@/plugins/custom-vuetify-themes'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { de },
    current: 'de',
  },
  icons: GLOBAL_VUETIFY_ICON_SET,
  theme: customVuetifyThemes
});
